<template>
  <div>
    <div class="sby-profile-list">
      <radio-group :value="value" @input="$emit('input', $event)">
        <van-swipe-cell
          v-for="(item, index) in list" 
          :key="item.id"
          :right-width="60"
        >
          <van-cell-group>
            <cell>
              <radio :name="item.id" @click="$emit('select', item, index)">
                <div style="font-weight:500;">
                  <span style="display: inline-block; width: 50px;">{{ item.name }} </span>
                  <span>{{ item.phone }}  <sby-member-icon v-if="item.vip === 1"/></span>
                </div>
                <div>
                  <van-tag
                    type="primary"
                    plain
                    class="small-tag"
                  >{{item.relation ? item.relation : '本人' }}</van-tag>
                  <span style="color: #b1b1b1; font-size: 12px;margin-left: 20px;">
                    {{ item.id_number }} 
                  </span>
                </div>
              </radio>
              <van-icon
                slot="right-icon"
                name="edit"
                @click="$emit('edit', item)"
              />
            </cell>
          </van-cell-group>
        <span class="removeList" @click="changeClick(item.id)" slot="right">删除</span>
      </van-swipe-cell>
    </radio-group>
    <cell
      icon="add"
      is-link
      class="van-hairline--top sby-profile-list__add"
      :title="addText"
      @click="$emit('add')"
    />
    </div>
  </div>
</template>

<script>
import {
  Radio,
  Icon,
  CellGroup,
  Cell,
  RadioGroup,
  SwipeCell,
  Card,
} from "vant";
import Vue from 'vue';
import '@vant/touch-emulator';
Vue.use(SwipeCell);
Vue.use(Card);
Vue.use(CellGroup);
export default {
  name: "profile-list",
  components: {
    Radio,
    Icon,
    RadioGroup,
    Cell,
    CellGroup,
    [SwipeCell.name]: SwipeCell,
  },
  props: {
    value: {},
    addText: String,
    list: {
      type: Array,
      default: () => []
    },
    itemObj: {
      type: Object,
      default: () => {}
    },
    onDelete: Function,
  },
  data() {
    return {
      showEdit: false,
      itemId: ""
    };
  },
  methods: {
    changeClick(id){
      this.$emit(
        "onDelete",
        id
      )
    }
  }
};
</script>


<style lang="less" scoped>
@import "../assets/less/var.less";
.van-icon-edit {
  margin-top: 15px;
}

.goods-card {
  margin: 0;
  // background-color: @white;
}

.delete-button {
  height: 100%;
}
.sby-profile-list {
  height: 100%;
  overflow-y: auto;
  padding-bottom: 55px;
  box-sizing: border-box;
  background-color: white;
  .removeList {
    display: inline-block;
    width: 60px;
    height: 62px;
    font-size: 15px;
    line-height: 62px;
    color: #fff;
    text-align: center;
    background-color: #f44;
  }

  .van-cell__value {
    color: #333;
    padding-right: 34px;
    position: relative;
  }

  .van-radio__label {
    margin-left: 32px;
  }

  .van-radio__input {
    top: 50%;
    left: 0;
    position: absolute;
    transform: translate(0, -50%);
  }

  .van-icon-checked {
    color: #38f;
  }

  &__text {
    margin: 0;
    color: #333;
    font-size: 14px;
    line-height: 1.5;
  }

  &__edit {
    position: absolute;
    top: 50%;
    right: 15px;
    font-size: 20px;
    color: #999;
    transform: translate(0, -50%);
  }

  &__add {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 9999;
    font-weight: 500;
    line-height: 36px;
    padding-left: 15px;
    font-size: 16px;

    .van-icon-add {
      color: #38f;
      font-size: 20px;
      line-height: 1.7;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sby-profile-list.vue